import type { IPayoutTransactionMinimal } from "../../../../types/models/payout-transaction.modals.types";
import { usePostHttp } from "../../http.hook";

export interface IPostResponse {
	payout: IPayoutTransactionMinimal;
}

export function usePayoutApproveAdminHttp() {
	return usePostHttp<null, IPostResponse>({
		path: "/admin/payouts/transactions/:id/approve",
	});
}
